import React, { useEffect, useRef, useState } from "react";
import SidePanel from "../../Components/SidePanel";
import ReactHelmet from "../../Components/ReactHelmet";
import Styles from "./ZoomApp.module.css";
import TopBar from "../../Components/TopBar";
import RightSidePanel from "../../Components/RightSidePanel";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../Core/api";
import Loading from "../../Components/Loading";
import MobileJoinZoom from "./MobileJoinZoom";

const JoinZoom = () => {
  const [SidebarOpen, SetSideBarOpen] = useState(false);
  const [OpenMenuBar2, setOpenMenuBar2] = useState(false);
  const [ZoomUrl, setZoomUrl] = useState("");
  const { Login_User } = useSelector((state) => state.USER_LOGIN_REDUCER);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [Contact_Id, setContact_Id] = useState("");
  const meetingNumber = query.get("key");
  const passWord = query.get("p");
  const Class_Id = query.get("cid");
  const Demo = query.get("d");
  const Navigate = useNavigate();
  const role = 0;

  const getSignature = async () => {
    try {
      const { data } = await api.post("/zoom/get-signature", {
        meetingNumber,
        role,
        Class_Id,
        Demo: Demo == 1 ? true : false,
      });
      // console.log(data);
      setContact_Id(data?.ContactId);
      return data.Result;
    } catch (ex) {
      Navigate(
        `/zoom/error?e=${
          ex.response && ex.response.data.Result
            ? ex.response.data.Result
            : ex.message
        }`
      );
      console.log(ex);
    }
  };

  const joinMeeting = async () => {
    const signature = await getSignature();

    let urlZoom = `https://zoom.testifyi.com/meeting.html?name=${Login_User?.First_Name}&mn=${meetingNumber}&email=&pwd=${passWord}&role=0&lang=en-US&id=${Contact_Id}&signature=${signature}&china=0&sdkKey=D_0YHlXuQHiE6ocREkIbmQ`;
    setZoomUrl(urlZoom);
    // await client.renderVideo({
    //   rootElement: document.getElementById("zoom-root"),
    // });
  };

  const Mobile_Screen = window.innerWidth;

  useEffect(() => {
    if (meetingNumber && passWord && Class_Id) {
      joinMeeting();
    }
  }, [meetingNumber, passWord, Class_Id, Demo]);

  const iframeRef = useRef(null);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     try {
  //       const currentUrl = iframeRef.current.contentWindow.location.href;
  //       if (currentUrl !== iframeUrl) {
  //         setIframeUrl(currentUrl);
  //         console.log("Iframe URL changed:", currentUrl);
  //       }
  //     } catch (err) {
  //       console.warn("Cross-origin iframe, cannot access URL.");
  //     }
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [iframeUrl]);

  return Mobile_Screen <= 480 ? (
    <MobileJoinZoom ZoomUrl={ZoomUrl} iframeRef={iframeRef} />
  ) : (
    <div className={Styles.Dashboard}>
      <ReactHelmet title={"Zoom"} description={"Zoom Link"} />
      {/* SidePanel */}
      {ZoomUrl ? " " : <Loading />}
      {Mobile_Screen >= 780 ? (
        <SidePanel
          SetSideBarOpen={SetSideBarOpen}
          SidebarOpen={SidebarOpen}
          SetSideBarOpen2={setOpenMenuBar2}
          SidebarOpen2={OpenMenuBar2}
          Page="Zoom"
        />
      ) : (
        ""
      )}

      {Mobile_Screen <= 480 && SidebarOpen ? (
        <SidePanel
          SetSideBarOpen={SetSideBarOpen}
          SidebarOpen={SidebarOpen}
          Page="Zoom Class"
        />
      ) : (
        ""
      )}

      <section className={Styles.MiddleSection}>
        <div style={{ marginTop: "30px" }}>
          <TopBar
            SetSideBarOpen={SetSideBarOpen}
            SidebarOpen={SidebarOpen}
            SetSideBarOpen2={setOpenMenuBar2}
            SidebarOpen2={OpenMenuBar2}
            PageName={"Zoom Class"}
          />
        </div>
        {/* <div
          id="zoom-root"
          ref={zoomContainerRef}
          style={{
            // backgroundColor: "#000",
            width: "60vw",
            heght: "700px",
          }}
        ></div> */}
        <div>
          {ZoomUrl ? (
            <iframe
              ref={iframeRef}
              src={ZoomUrl}
              width="100%"
              height={window.innerWidth <= 580 ? "530" : "600"}
              frameborder="0"
              id="zoom-frame"
              allow="microphone; camera;display-capture; fullscreen"
              allowfullscreen
              webkitallowfullscreen
              mozallowfullscreen
              // onLoad={() => {
              //   setTimeout(() => {
              //     console.log("marked_arr");
              //     // fetch("/api/mark-attendance", {
              //     //   method: "POST",
              //     //   body: JSON.stringify({ userId }),
              //     //   headers: { "Content-Type": "application/json" },
              //     // });
              //   }, 10000); // 10-second confirmation
              // }}
            >
              {" "}
            </iframe>
          ) : (
            ""
          )}{" "}
        </div>

        {/* <button onClick={goFullscreen}>Enter Fullscreen</button>
        <button onClick={() => shrinkVideo()}>shrink </button> */}
      </section>

      <RightSidePanel
        SetSideBarOpen={setOpenMenuBar2}
        SidebarOpen={OpenMenuBar2}
      />

      <div
        onClick={() => {
          SetSideBarOpen(false);
          setOpenMenuBar2(false);
        }}
        className={SidebarOpen || OpenMenuBar2 ? "overlay active" : "overlay"}
        id="overlay"
      ></div>
    </div>
  );
};

export default JoinZoom;
